import { render, staticRenderFns } from "./RecordedSmallCard.vue?vue&type=template&id=51413a03&scoped=true&"
import script from "./RecordedSmallCard.vue?vue&type=script&lang=ts&"
export * from "./RecordedSmallCard.vue?vue&type=script&lang=ts&"
import style0 from "./RecordedSmallCard.vue?vue&type=style&index=0&id=51413a03&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51413a03",
  null
  
)

export default component.exports